module.exports = __webpack_public_path__ + "img/ryzhkov_rostyslav.e9dc7569.png";